function useExponentialSlider(steps, bounds, linear) {
  const config = resolveConfig(steps, bounds, linear);
  return {
    stepToModel: (step) => stepToModelInternal(step, config),
    modelToStep: (model) => modelToStepInternal(model, config),
    config
  };
}
function stepToModel(step, steps, bounds, linear) {
  return stepToModelInternal(step, resolveConfig(steps, bounds, linear));
}
function stepToModelInternal(step, config) {
  const { linearPercent, linearAbsolute, steps, range, min, max } = config;
  step = limitBounds(step, { min: 0, max: steps });
  const percent = step / steps;
  if (linearAbsolute >= max) {
    return percent * range + min;
  }
  if (1 === linearPercent) {
    return percent * range + min;
  }
  if (percent <= linearPercent) {
    const percentOfAbsolute = linearPercent > 0 ? percent / linearPercent : 0;
    return percentOfAbsolute * linearAbsolute + min;
  }
  const linear = linearPercent > 0 ? Math.min(percent, linearPercent) / linearPercent * linearAbsolute : 0;
  const rangeExponential = range - linearAbsolute;
  const remainder = step - steps * linearPercent;
  const expPercent = 1 - linearPercent;
  const percentOfMax = remainder / (steps * expPercent);
  const expVal = percentOfMax * rangeExponential;
  return linear + expRange(expVal, 0, rangeExponential) + min;
}
function modelToStep(model, steps, bounds, linear) {
  return modelToStepInternal(model, resolveConfig(steps, bounds, linear));
}
function modelToStepInternal(model, config) {
  const { linearPercent, linearAbsolute, steps, range, min, max } = config;
  model = limitBounds(model, { min, max });
  const actualValue = Math.max(model - min, 0);
  if (linearAbsolute >= max) {
    const percent = actualValue / range;
    return Math.round(percent * steps);
  }
  if (1 === linearPercent) {
    return Math.round(actualValue / range * steps);
  }
  if (linearAbsolute > 0 && actualValue <= linearAbsolute) {
    const percent = actualValue / linearAbsolute * linearPercent;
    return Math.round(percent * steps);
  }
  const remainderValue = actualValue - linearAbsolute;
  const rangeExponential = range - linearAbsolute;
  const dynamicPercent = 1 - linearPercent;
  const percentOfMax = rootRange(remainderValue, 0, rangeExponential) / rangeExponential;
  return Math.round(
    steps * linearPercent + percentOfMax * steps * dynamicPercent
  );
}
function resolveConfig(steps, bounds, linear) {
  linear || (linear = {
    maxLinear: 0,
    linearPercent: 0
  });
  const linearPercent = limitBounds(linear.linearPercent, { min: 0, max: 100 }) / 100;
  const linearAbsolute = Math.min(
    linear.maxLinear,
    Math.round(bounds.max * linearPercent)
  );
  return {
    steps,
    linearAbsolute,
    linearPercent,
    min: bounds.min,
    max: bounds.max,
    range: bounds.max - bounds.min
  };
}
function limitBounds(value, bounds) {
  return Math.min(Math.max(value, bounds.min), bounds.max);
}
function expRange(value, min, max) {
  const range = max - min;
  return Math.pow(value / range, 2) * range + min;
}
function rootRange(value, min, max) {
  const range = max - min;
  return Math.sqrt(Math.max(0, value - min) / range) * range;
}
export {
  limitBounds,
  modelToStep,
  modelToStepInternal,
  resolveConfig,
  stepToModel,
  stepToModelInternal,
  useExponentialSlider
};
